import { useSmsUpStore } from '@/stores'

export const initJSONPInterceptor = () => {
  const originalCreateElement = Document.prototype.createElement

  function proxy(dom) {
    let src
    Object.defineProperty(dom, 'src', {
      get: function () {
        return src
      },
      set: function (newVal) {
        src = newVal
        dom.setAttribute('src', newVal)
      },
    })

    let originalSetAttribute = dom.setAttribute
    dom.setAttribute = function () {
      let args = Array.prototype.slice.call(arguments)
      let key = args[0]
      let val = args[1]
      // 根据script中的src即url地址上是否存在callback=粗略判断是否为JSONP的调用
      if (
        key === 'src' &&
        (val.includes('http://c.dun.163.com/api/v3/get') ||
          val.includes('http://c.dun.163yun.com/api/v3/get')) &&
        val.includes('callback=')
      ) {
        const url = new URL(val)
        const callbackName = url.searchParams.get('callback')

        const originalCallback = window[callbackName]

        window[callbackName] = function (data) {
          const smsUpStore = useSmsUpStore()
          smsUpStore.setCode(data.data.front)

          // 调用原始回调函数（如果需要）
          if (originalCallback) {
            originalCallback(data)
          }
        }

        originalSetAttribute.apply(dom, [key, val])
      } else {
        originalSetAttribute.apply(dom, args)
      }
    }
  }
  // 重写创建节点函数
  Document.prototype.createElement = function (tagName) {
    let dom = originalCreateElement.call(this, tagName)

    if (tagName.toLowerCase() === 'script') {
      proxy(dom)
    }
    return dom
  }
}
